import ThreeBadge from '../../content/assets/three-js-ico.png';

const technologies = [
    {
        title: 'HTML5',
        source: 'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/html/html.png',
        alt: 'HTML5'
    },
    {
        title: 'CSS3',
        source: 'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/css/css.png',
        alt: 'CSS3'
    },
    {
        title: 'JAVASCRIPT',
        source: 'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/javascript/javascript.png',
        alt: 'JAVASCRIPT'
    },
   
    {
        title: 'NODEJS',
        source: 'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/nodejs/nodejs.png',
        alt: 'NODEJS'
    },
    {
        title: 'PHP',
        source: "https://img.shields.io/badge/php-%23777BB4.svg?style=for-the-badge&logo=php&logoColor=white",
        alt: 'PHP'
    },
    {
        title: 'BITBUCKET',
        source: 'https://user-images.githubusercontent.com/25181517/192108375-268c35e6-ab26-44b2-88bf-e3121a4e5083.png',
        alt: 'BITBUCKET'
    },
    {
        title: 'GIT',
        source: 'https://user-images.githubusercontent.com/25181517/192108372-f71d70ac-7ae6-4c0d-8395-51d8870c2ef0.png',
        alt: 'GIT'
    },
    {
        title: 'ANGULAR',
        source: 'https://img.shields.io/badge/angular-%23DD0031.svg?style=for-the-badge&logo=angular&logoColor=white"',
        alt: 'ANGULAR'
    },
]

export default technologies;